import React from "react";
import TwitterQuote from "./components/twitterQuote";
import Box from "../../../../components/box";
import "./styles.css";

class TwitterQuotes extends React.Component {
  componentDidMount() {
    // const mobile = document.getElementById("twitter-quote-trustbox-mobile");
    // const desktop = document.getElementById("twitter-quote-trustbox-desktop");
    const widget = document.getElementById("trustpilot-widget-free");
    const loadFromElement = () => {
      if (window.Trustpilot) {
        // window.Trustpilot.loadFromElement(mobile);
        // window.Trustpilot.loadFromElement(desktop);
        window.Trustpilot.loadFromElement(widget);
      } else {
        setTimeout(loadFromElement, 500);
      }
    };
    loadFromElement();
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    return (
      <div className="twitter-quotes" id="testimonials">
        <Box>
          <h2>What people think</h2>
          <div className="quotes-wrapper">
            <TwitterQuote
              date="12:07 AM - Jan 15, 2019"
              name="Sorikal"
              username="@Sorikals"
              twitterLink="https://twitter.com/Sorikals"
            >
              Just wanted to vouch for this really good program that made me
              great at pvp again. @ghastapp ❤️
            </TwitterQuote>
            <TwitterQuote
              date="5:40 AM - 27 Jan 2019"
              name="Edvin"
              username="@ioalore"
              twitterLink="https://twitter.com/ioalore"
            >
              @ghastapp has definitely stepped up my PvP. Was skeptic at first
              but I do not regret a single penny. Totally worth the purchase! 🤪
            </TwitterQuote>
            <TwitterQuote
              date="8:57 PM - 27 Jan 2019"
              name="ItssCookie"
              username="@Itss_Cookie"
              twitterLink="https://twitter.com/Itss_Cookie"
            >
              @ghastapp Best pvp enhancement software by far! Hyped for ghast
              lightning!
            </TwitterQuote>
          </div>

          {/* <div
            id="trustpilot-widget-free"
            class="trustpilot-widget"
            data-locale="en-GB"
            data-template-id="5419b6a8b0d04a076446a9ad"
            data-businessunit-id="5c3cae791aa59c0001976ef2"
            data-style-height="24px"
            data-style-width="100%"
            data-theme="light"
          >
            <a
              href="https://uk.trustpilot.com/review/ghast.io"
              target="_blank"
              rel="noopener"
            >
              Trustpilot
            </a>
          </div> */}

          <div
            id="trustpilot-widget-free"
            class="trustpilot-widget"
            data-locale="en-GB"
            data-template-id="5613c9cde69ddc09340c6beb"
            data-businessunit-id="5c3cae791aa59c0001976ef2"
            data-style-height="100%"
            data-style-width="100%"
            data-theme="light"
          >
            <a
              href="https://uk.trustpilot.com/review/ghast.io"
              target="_blank"
              rel="noopener"
            >
              Trustpilot
            </a>
          </div>

          {/* <div className="trustbox-mobile">
            <div
              id="twitter-quote-trustbox-mobile"
              className="trustpilot-widget"
              data-locale="en-GB"
              data-template-id="539ad0ffdec7e10e686debd7"
              data-businessunit-id="5c3cae791aa59c0001976ef2"
              data-style-height="300px"
              data-style-width="100%"
              data-theme="light"
              data-stars="4,5"
              data-schema-type="Organization"
            >
              {" "}
              <a
                href="https://uk.trustpilot.com/review/ghast.io"
                target="_blank"
              >
                Trustpilot
              </a>{" "}
            </div>
          </div> */}
          {/* <div className="trustbox-desktop">
            <div
              id="twitter-quote-trustbox-desktop"
              className="trustpilot-widget"
              data-locale="en-GB"
              data-template-id="53aa8912dec7e10d38f59f36"
              data-businessunit-id="5c3cae791aa59c0001976ef2"
              data-style-height="130"
              data-style-width="100%"
              data-theme="light"
              data-stars="4,5"
              data-schema-type="Organization"
            >
              {" "}
              <a
                href="https://uk.trustpilot.com/review/ghast.io"
                target="_blank"
              >
                Trustpilot
              </a>{" "}
            </div>
          </div> */}
          {/* <div onClick={() => window.scrollTo(0, 0)}>
            <A className="review-link" href="/reviews">
              ghast.io reviews
            </A>
          </div> */}
        </Box>
      </div>
    );
  }
}

export default TwitterQuotes;



/** WEBPACK FOOTER **
 ** ./src/views/pages/home/sections/twitterQuotes/index.js
 **/